import React, { useEffect } from 'react'
import {
  setFocus,
  FocusContext,
  useFocusable,
} from '@noriginmedia/norigin-spatial-navigation'

import tts from '../../lib/TTS.js'
import FocusableButtonTS from '../../components/FocusableButton/FocusableButtonTS'

import { ManageDonationComponentsEnums } from './types'
import ErrorDescription from '../../components/ErrorModal/ErrorDescription'
import { ErrorBody } from '../../../../shared/PBSError/index.js'
import { getErrorDescriptionDetails } from '../../lib/helpers'

const BUTTON_KEY = 'BACK'

type CancelDonationErrorProps = {
  error: ErrorBody
  onEnterPress: (arg0: ManageDonationComponentsEnums) => void
}

export const CancelDonationError = ({
  error,
  onEnterPress,
}: CancelDonationErrorProps) => {
  const { ref } = useFocusable()
  const pbsError = error.errorMessage.e

  const { errorText, errorCodePrefix, errorDetails } =
    getErrorDescriptionDetails(pbsError)

  const errorTitle = 'We encountered a problem while cancelling your donations'

  useEffect(() => {
    tts.addTextToRead(
      `${errorTitle} ... ${errorText} ... ${errorCodePrefix} ... ${errorDetails}.`
    )
    setFocus(BUTTON_KEY)
  }, [])

  const handleEnterPress = () => {
    onEnterPress(ManageDonationComponentsEnums.ROOT)
    tts.enqueueTextToRead(`Pressed go back button.`)
  }

  const handleFocus = () => {
    tts.enqueueTextToRead('Focus on go back button.')
  }

  return (
    <FocusContext.Provider value="cancel-donation-error">
      <div className="cancellation-donation-screen__error" ref={ref}>
        <h1 className="cancellation-donation-screen__error__title">
          {errorTitle}
        </h1>
        <ErrorDescription e={pbsError} />
        <FocusableButtonTS
          onEnterPress={handleEnterPress}
          onFocus={handleFocus}
          className="cancellation-donation-screen__error__back-button"
          focusKey={BUTTON_KEY}
        >
          Go back
        </FocusableButtonTS>
      </div>
    </FocusContext.Provider>
  )
}
